
import { AfterViewInit, Component, EventEmitter, Input, Output } from '@angular/core';
import { AttachmentDto, AttachmentFileType } from '../attachment';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BaseComponent } from 'src/app/shared/components/component-base';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-attachment-input',
  templateUrl: './attachment-input.component.html',
  styleUrls: ['./attachment-input.component.css']
})
export class AttachmentInputComponent extends BaseComponent implements AfterViewInit  {
  @Input() labelKey: string;
  @Input() controls: string;
  @Input() ShowCreatedOn:boolean = false;
  @Input() multiple: boolean = false;
  @Input() viewOnly: boolean = false;
  @Input() hideDeleteBtn : boolean=false;
  @Input() acceptedFileTypes: AttachmentFileType[] = [1];
  @Input() displayFileLanguage: boolean = false;
  @Input() displayDiscription: boolean = false;
  @Input() attachments: AttachmentDto[] | any = [];
  @Output() onDelete = new EventEmitter<string>();
  @Input() attachment!: AttachmentDto;
  @Input() maxFilesNumber: number = 6;
  @Input() isRequired: boolean = false;
  @Input() validationEnabled: boolean = false;
  @Input() languageSelection: boolean = false;
  @Input() sizeWithKB: number =  25 * 1024 * 1024;
  @Input() maxNumberOfFiles: number = 6;
  @Input() descriptionEnable: boolean = false;
  @Input() placeholder: string;
  @Input() form: FormGroup<any> = null;
  @Output() onSaved = new EventEmitter<AttachmentDto>();
  @Output() onSavedFile = new EventEmitter<File>();
  exceedFileNumber: boolean = false;
  public attachmentFileType = AttachmentFileType;
  public file!: File | null;

  constructor(
    public translate: TranslateService,
    private formBuilder :FormBuilder
  ) {
    super();
    if (this.validationEnabled) {
      this.isRequired = this.validationEnabled;
    }
  }
  ngAfterViewInit() {
    this.loadToolTipJs();
    this.initializeForm();
    this.loadToolTipJs();
  }
 
  
  private initializeForm() {
    if (!this.form) {
      this.createForm();
    }
    if (!this.controls) {
      this.addDummyControl();
    }
  }
  
  private createForm() {
    this.form = this.formBuilder.group({
      DummyControl: [[]]
    });
  }
    
  private addDummyControl() {
    const dummyControlName = 'DummyControl';
    if (!this.form.get(dummyControlName)) {
      this.form.addControl(dummyControlName, this.formBuilder.control([]));
    }
    this.controls = dummyControlName;
  }
  getFileNumberExceededMessage(): string {
    return this.translate.instant('validation.fileNumberExceeded', { fileNumber: this.maxFilesNumber });
  }
  deleteConventionAttachment(attachmentId: string) {
    this.updateControl();
    this.onDelete.emit(attachmentId);
  }
  addConventionAttachmentFile(attachFile: File) {

    this.onSavedFile.emit(attachFile);
  }
  RepeatedFile:boolean=false;
  addConventionAttachment(attachment: AttachmentDto) {
    var notDeletedFiles = this.attachments.filter(a => !a.isDeleted);
    if (notDeletedFiles.length < this.maxFilesNumber) {
      let attachmentsFile: AttachmentDto = {
        fileName: attachment.fileName,
        size: attachment.size,
        contentType: attachment.contentType,
        fileContent: attachment.fileContent,
        isNew: true,
        entityAttachmentId: attachment.id,
        description: attachment.description,
        extension: attachment.extension,
        filePath: attachment.filePath,
        id: attachment.id,
        isDeleted: false
      };

      var checkifFileExist = this.attachments.filter(obj => obj.fileName == attachmentsFile.fileName)[0];
      if(checkifFileExist==null || checkifFileExist== undefined){
        this.attachments.push(attachmentsFile);
        this.updateControl();
      }else{
        this.RepeatedFile = true;
        this.exceedFileNumber = false;
      }
      
    }
    else {
      this.exceedFileNumber = true;
      this.RepeatedFile = false;
    }
    attachment.isNew = true;
    this.onSaved.emit(attachment);

  }
  updateControl() {
    this.exceedFileNumber = false;
    this.RepeatedFile = false;
    if (this.controls) {
       this.form.get(this.controls).markAsTouched();
       this.form.get(this.controls).patchValue(this.attachments);
       this.form.get(this.controls).updateValueAndValidity();
      if (this.isRequired && !this.isContainsAttachments()) {
        this.form.get(this.controls).setErrors({ requiredValidAttachment: true })
      }
    }
  }

  isContainsAttachments() {
    if (!Array.isArray(this.attachments) || !this.attachments.length) {
      return false;
    }
    return this.attachments.some(
      (attachment) => attachment.isDeleted !== true
    );
  }
}

